import React from "react"
import { FaStar } from "react-icons/fa"

export default function TestimonialCard({
  id,
  reff,
  comment,
  position,
  location,
  author,
}) {
  return (
    <div
      ref={reff}
      className={`p-4 bg-white rounded shadow-xl shadow-stone-600/10 w-72 sm:w-72 lg:w-[520px] relative pb-20 ${id}`}
    >
      <div className="flex space-x-2 items-center text-yellow-500">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </div>
      <div className="py-2">
        <p
          className="text-sm lg:text-lg font-thin leading-8 lg:leading-9 before:content-['“'] after:content-['”']"
          dangerouslySetInnerHTML={{ __html: comment }}
        />
      </div>
      <div className="absolute bottom-0 left-0 mb-4 ml-4">
        <div className="text-sm">
          <h3 className="font-bold text-teal-600 text-lg">
            {author}, <i className="text-stone-700 text-xs">{position}</i>
          </h3>
          <p className="tracking-widest text-xs uppercase">{location}</p>
        </div>
      </div>
    </div>
  )
}
